<template>
    <v-container>
      <v-row>
        <v-col md="12" class="pa-6 text-left text-justify">
          <div class="my-6">
              <p class="text-h4 text--primary">
                  <TextHeading :level=3>Nasze przygotowane wnioski o dofinansowanie</TextHeading>
              </p>
              <span v-for="(paragraph, i) in paragraphs"
                    :key="i">
                    <p class="text--primary">
                        <TextHeading :level=5>{{ paragraph.title }}</TextHeading>
                    </p>
                    <span v-for="(section, j) in paragraph.sections" :key="j">
                        <div v-if="section.type == 'paragraph'" :id="section.cssId" class="text-body-1 text--primary" v-html="section.text"></div>
                        <p v-if="section.type == 'special_paragraph'" class="text--primary">
                            <TextHeading :level=6>{{ section.text }}</TextHeading>
                        </p>
                        <span v-if="section.type == 'list'">
                            <div class="text-body-1 text--primary" :id="section.cssId" v-html="section.text"></div>
                            <v-list dense disabled>
                                <v-list-item
                                    v-for="(point, k) in section.points"
                                    :key="k"
                                >
                                    <v-list-item-icon>
                                        <v-icon>{{ section.icon }}</v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-content>
                                        <v-list-item-title ><span class="text-wrap text-body-1" v-html="point"></span></v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-list>
                        </span>
                        <br />
                    </span>
                </span>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </template>
  <script>
  import TextHeading from "@/modules/TextHeading";
  export default {
  
    components: {TextHeading},
  
    data: () => ({
      paragraphs: [
        {
            title: "",
            sections: [
                {
                    text: "",
                    type: "list",
                    icon: "mdi-circle-medium",
                    points: [
                      "Print Group Sp. z o. o - w  ramach realizacji projektu pn. „Budowa instalacji fotowoltaicznej umożliwiającej wykorzystanie odnawialnych źródeł energii przez firmę Print Group Sp. z o.o. w Szczecinie - budynek I”  powstała instalacja fotowoltaiczna o mocy 90 kW;",
                      "Wyroby Granitowe Wołczyk Sp. J. - w ramach realizacji projektu pn. „Budowa wolnostojącej naziemnej instalacji fotowoltaicznej wraz z niezbędnymi urządzeniami technicznymi na potrzeby firmy Wyroby Granitowe Wołczyk Sp. J.” powstała instalacja fotowoltaiczna  o mocy 40 kW;",
                      "All-Pol Sp. J.  Piotr Bogdaniec, Paweł Serafin - w ramach realizacji projektu pn. „Rozwój działalności firmy ALL-POL Sp. J. poprzez budowę instalacji fotowoltaicznej” powstała instalacja fotowoltaiczna o mocy 40 kW;",
                      "Hydrogryf Sp. z o.o. - w ramach realizacji projektu pn. „Rozwój działalności spółki ,,Hydrogryf,, poprzez zakup i montaż instalacji fotowoltaicznej”  powstała instalacja fotowoltaiczna o mocy 40 kW;",
                      "Przedsiębiorstwo PKS Gryfice Sp z o.o. - w ramach realizacji projektu pn. „Zwiększenie wykorzystania odnawialnych źródeł w Przedsiębiorstwie PKS Gryfice Sp. z o.o. poprzez inwestycję w wysokosprawną instalację fotowoltaiczną o mocy 95,16 kW” powstała instalacja fotowoltaiczna o mocy 95,16 kW;",
                      "Przedsiębiorstwo Partner Sp z o.o. - w ramach realizacji projektu pn.  „Zwiększenie wykorzystania odnawialnych źródeł energii przez Przedsiębiorstwo Partner sp. z o.o. w Szczecinie w celu budowania gospodarki niskoemisyjnej regionu” powstała instalacja fotowoltaiczna o mocy 40 kW;",
                      "Gastro-Tour Jarosław Ruta - w ramach realizacji projektu pn.  „Montaż paneli fotowoltaicznych przez firmę Gastro Tour na potrzeby własne”, powstała instalacja fotowoltaiczna  o mocy 30 KW;",
                      "„Jan - Pol” Janusz Rzezak - w ramach realizacji projektu pn. „Montaż instalacji fotowoltaicznej dla dwóch budynków pizzerii w Wolinie” powstała instalacja fotowoltaiczna  o mocy 34 kW;",
                      "Grzegorz Kotwicki - w ramach realizacji projektu pn. „Zwiększenie produkcji energii ze źródeł odnawialnych, wykorzystywanej na potrzeby Ośrodka Agroturystycznego ,,Młyn nad Starą Regą,, powstała instalacja fotowoltaiczna o mocy 40 kW oraz dwie pompy ciepła o mocy 138 kW łącznie;",
                      "Power Sol Sp. z o.o. - w ramach realizacji projektu pn. „Budowa instalacji fotowoltaicznej o mocy do 1 MW wraz z niezbędną infrastrukturą w miejscowości Grabów” powstała instalacja fotowoltaiczna o mocy 1 MW;",
                      "Siła Mazur Sp. z o.o. - w ramach realizacji projektu pn. „Inwestycje w OZE w przedsiębiorstwie Siła Mazur” powstała instalacja o mocy 1,1 MW;",
                      "Słoneczna Energia Mazury Sp. z o.o. - w ramach realizacji projektu pn.  „Budowa elektrowni fotowoltaicznej o mocy 0,48MW na działce nr 129/9, obręd Miłki, gm.Miłki”   powstała instalacja o mocy 480 kW;",
                      "Elektrownia Słoneczna Kosinowo Sp. z o.o.  -  w ramach realizacji projektu pn. „Budowa elektrowni fotowoltaicznej o mocy 0,56MW na działce nr 3/55 obręb Krzywińskie, gm. Prostki” powstała instalacja o mocy  560 KW;",
                      "Przedsiębiorstwo Handlowo-Produkcyjne Lizer S.C. Grzegorz Lizer, Maria Zarzycka - w ramach realizacji projektu pn. „Zakup i montaż mikroinstalacji fotowoltaicznych o łącznej mocy 34,45 kW w firmie PHP „LIZER” S.C.” powstała instalacja fotowoltaiczna o mocy 34,16 kW;",
                      "Słoneczne Tumiany Sp. z o.o. w ramach realizacji projektu pn. „Budowa elektrowni fotowoltaicznej o mocy 0,9 MW na działce nr 14/1, obręb Tumiany, gmina Barczewo” powstała instalacja fotowoltaiczna o mocy  900 KW”",
                      "Voltasol Sp. z o.o.  - w ramach  realizacji projektu pn. „Budowa elektrowni fotowoltaicznej o mocy 1MW na działce nr 248/2, obręb Robawy, gmina Reszel” powstała instalacja fotowoltaiczna  mocy 1  MW.",
                    ],
                    cssId: "funds"
                },
            ]
        },
      ]
    }),
  }
  </script>
  